var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bootstrap-typeahead',{ref:"search",class:{ 'field-error' : _vm.$v.value.name.$error },attrs:{"data":_vm.items,"value":_vm.search,"serializer":s => s[_vm.searchKey],"placeholder":_vm.placeholder},on:{"hit":_vm.onSelected,"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }